<template>
  <div id="app">
    <div class="app-wrapper" :class="{hideSidebar: !sidebar.opened || !$store.getters.isAdmin}">
      <header-component></header-component>
      <router-view></router-view>
    </div>
  </div>
</template>

<script>
  import HeaderComponent from '@/components/Header'
  import Sidebar from '@/components/sidebar'

  export default {
    name: 'App',
    components: {
      HeaderComponent,
      Sidebar
    },
    data() {
      return {}
    },
    mounted(){
      this.$moment.lang('ru')
    },
    computed: {
      sidebar() {
        return this.$store.state.app.sidebar
      }
    },
  }
</script>

<style lang="scss" src="./assets/styles/index.scss"></style>



// WEBPACK FOOTER //
// src/App.vue